module.exports = __webpack_public_path__ + "img/img_service_001.05a6264d.png";